import { InvestmentFormValues } from "./types";

const slugSpecificDefaults: Record<string, Partial<InvestmentFormValues>> = {
  real_estate: {
    propertyType: "",
    propertyTypeOther: "",
    area: "",
    city: "",
    postalCode: "",
    address: "",
  },
  precious_stones: {
    mass: "",
    cut: "",
    color: "",
    clarity: "",
  },
  precious_metals: {
    propertyType: "",
    mass: "",
    fineness: "",
  },
  treasury_bonds: {
    interestType: "",
    interestRate: "",
  },
  artwork: {
    author: "",
    eraAge:"",
    artworkType: "",
    unknownAuthor: false,
  },
  investment_policy: {
    contractDate: "",
    premiumPayment: "",
    durationDate: "",
    durationDateValue: "",
  },
  loans: {
    autoRenewal: "",
    loanType: "lent",
    entity: "",
    interestPayment: "",
    interestRate: "",
    durationDate: "",
    durationDateValue: "",
  },
  crypto: {
    parentInvestmentUuid: "",
  },
};

export const getInitialValues = (
  slug: string,
  defaults?: Partial<InvestmentFormValues>,
): InvestmentFormValues => {
  return {
    investmentTypeSlug: slug,
    name: "",
    primaryValue: "",
    currencyUuid: "",
    quantity: "",
    purchaseRate: "",
    additionalInfo: "",
    relianceCanView: false,
    status: "",
    contractFile: null,
    photoFiles: null,
    parentInvestmentUuid: "",
    ...(slugSpecificDefaults[slug] || {}),
    ...defaults,
  };
};
